function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496 496",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M323.2,84.8c5.6-22.4,22.4-46.4,39.2-50.4l0,0l0,0l0,0l0,0c12,11.2,15.2,40,9.6,62.4 s-19.2,32-35.2,36l0,0l0,0l0,0l0,0C324,122.4,316.8,108,323.2,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M336.8,134.4L336.8,134.4L336.8,134.4C336,134.4,336,134.4,336.8,134.4L336.8,134.4 c-12.8-11.2-19.2-26.4-13.6-48.8s22.4-46.4,39.2-50.4l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M381.6,119.2c18.4-18.4,48-31.2,65.6-26.4l0,0l0,0l0,0l0,0c5.6,17.6-8,47.2-26.4,65.6 s-36.8,20-54.4,15.2l0,0l0,0l0,0l0,0C361.6,155.2,363.2,137.6,381.6,119.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M367.2,173.6L367.2,173.6C366.4,173.6,366.4,173.6,367.2,173.6C366.4,173.6,366.4,173.6,367.2,173.6 L367.2,173.6c-5.6-18.4-4-36,14.4-54.4s48-31.2,65.6-26.4l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M435.2,258.4c22.4,7.2,45.6,24.8,48.8,41.6l0,0l0,0l0,0l0,0c-12,12-41.6,13.6-64,6.4 s-32-20.8-35.2-37.6l0,0l0,0l0,0l0,0C396.8,257.6,412.8,251.2,435.2,258.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M384.8,269.6L384.8,269.6L384.8,269.6L384.8,269.6L384.8,269.6c12-12,27.2-18.4,49.6-11.2 c22.4,7.2,45.6,24.8,48.8,41.6l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M417.6,324c17.6,12,32.8,34.4,31.2,49.6l0,0H448l0,0l0,0c-13.6,7.2-39.2,0.8-56.8-12 c-17.6-12-21.6-27.2-20-42.4l0,0l0,0l0,0l0,0C385.6,312.8,400.8,311.2,417.6,324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M371.2,320L371.2,320L371.2,320C371.2,319.2,371.2,319.2,371.2,320L371.2,320c13.6-7.2,28.8-8,46.4,4 s32.8,34.4,31.2,49.6l0,0H448l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M384.8,380c12,15.2,19.2,37.6,13.6,50.4l0,0l0,0l0,0l0,0c-13.6,2.4-33.6-9.6-45.6-24.8 c-12-15.2-12-28-6.4-40.8l0,0l0,0l0,0l0,0C360,362.4,372.8,365.6,384.8,380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M346.4,364.8L346.4,364.8L346.4,364.8L346.4,364.8L346.4,364.8c13.6-2.4,26.4,0,38.4,15.2 s19.2,37.6,13.6,50.4l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M347.2,461.6L347.2,461.6c-9.6,0-24-12.8-30.4-24.8c-7.2-12-5.6-22.4,0-30.4l0,0l0,0l0,0l0,0 c10.4,0,19.2,3.2,26.4,16C349.6,433.6,352,452.8,347.2,461.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M316.8,405.6L316.8,405.6L316.8,405.6L316.8,405.6L316.8,405.6c10.4,0,19.2,3.2,26.4,15.2 c7.2,12,9.6,31.2,4,40"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M428,185.6c26.4-2.4,57.6,5.6,68,21.6l0,0l0,0l0,0l0,0c-7.2,17.6-36,32-61.6,34.4s-41.6-7.2-52-22.4 l0,0l0,0l0,0l0,0C389.6,201.6,402.4,188.8,428,185.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M382.4,219.2L382.4,219.2L382.4,219.2L382.4,219.2L382.4,219.2c7.2-17.6,20-30.4,45.6-33.6 c26.4-2.4,57.6,5.6,68,21.6l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M172.8,84.8c-5.6-22.4-22.4-46.4-39.2-50.4l0,0l0,0l0,0l0,0c-12,11.2-15.2,40-9.6,62.4 c5.6,22.4,19.2,32,35.2,36l0,0l0,0l0,0l0,0C172,122.4,179.2,108,172.8,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M159.2,134.4L159.2,134.4L159.2,134.4C160,134.4,160,134.4,159.2,134.4L159.2,134.4 c12.8-11.2,19.2-26.4,13.6-48.8c-5.6-22.4-22.4-46.4-39.2-50.4l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M114.4,119.2C96,100.8,66.4,88,48.8,92.8l0,0l0,0l0,0l0,0c-5.6,17.6,8,47.2,26.4,65.6 s36.8,20,54.4,15.2l0,0l0,0l0,0l0,0C134.4,155.2,132.8,137.6,114.4,119.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M128.8,173.6L128.8,173.6C129.6,173.6,129.6,173.6,128.8,173.6C129.6,173.6,129.6,173.6,128.8,173.6 L128.8,173.6c5.6-18.4,4-36-14.4-54.4S66.4,88,48.8,92.8l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M60.8,258.4C38.4,265.6,15.2,283.2,12,300l0,0l0,0l0,0l0,0c12,12,41.6,13.6,64,6.4s32-20.8,35.2-37.6 l0,0l0,0l0,0l0,0C99.2,257.6,83.2,251.2,60.8,258.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M111.2,269.6L111.2,269.6L111.2,269.6L111.2,269.6L111.2,269.6c-12-12-27.2-18.4-49.6-11.2 C39.2,265.6,16,283.2,12.8,300l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M78.4,324c-17.6,12-32.8,34.4-31.2,49.6l0,0H48l0,0l0,0c13.6,7.2,39.2,0.8,56.8-12 c17.6-12,21.6-27.2,20-42.4l0,0l0,0l0,0l0,0C110.4,312.8,95.2,311.2,78.4,324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M124.8,320L124.8,320L124.8,320C124.8,319.2,124.8,319.2,124.8,320L124.8,320 c-13.6-7.2-28.8-8-46.4,4s-32.8,34.4-31.2,49.6l0,0H48l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M111.2,380c-12,15.2-19.2,37.6-13.6,50.4l0,0l0,0l0,0l0,0c13.6,2.4,33.6-9.6,45.6-24.8 c12-15.2,12-28,6.4-40.8l0,0l0,0l0,0l0,0C136,362.4,123.2,365.6,111.2,380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M149.6,364.8L149.6,364.8L149.6,364.8L149.6,364.8L149.6,364.8c-13.6-2.4-26.4,0-38.4,15.2 S92,417.6,97.6,430.4l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M148.8,461.6L148.8,461.6c9.6,0,24-12.8,30.4-24.8c7.2-12,5.6-22.4,0-30.4l0,0l0,0l0,0l0,0 c-10.4,0-19.2,3.2-26.4,16C146.4,433.6,144,452.8,148.8,461.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M179.2,405.6L179.2,405.6L179.2,405.6L179.2,405.6L179.2,405.6c-10.4,0-19.2,3.2-26.4,15.2 s-9.6,31.2-4,40l0,0c0,0,0-2.4,0,0l0,0V460"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#239B02"
    },
    d: "M68,185.6c-26.4-2.4-57.6,5.6-68,21.6l0,0l0,0l0,0l0,0c7.2,17.6,36,32,61.6,34.4s41.6-7.2,52-22.4 l0,0l0,0l0,0l0,0C106.4,201.6,93.6,188.8,68,185.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#34B515"
    },
    d: "M113.6,219.2L113.6,219.2L113.6,219.2L113.6,219.2L113.6,219.2c-7.2-17.6-20-30.4-45.6-33.6 c-26.4-2.4-57.6,5.6-68,21.6l0,0l0,0l0,0l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00A1AD"
    },
    d: "M325.6,246.4L325.6,246.4L248,88.8l-78.4,157.6l0,0c-4.8,10.4-8,22.4-8,35.2 c0.8,47.2,39.2,85.6,86.4,85.6s85.6-38.4,85.6-85.6C333.6,269.6,330.4,257.6,325.6,246.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#027F89"
    },
    d: "M248,367.2c47.2,0,85.6-38.4,85.6-85.6c0-12.8-2.4-24.8-7.2-35.2l0,0L248,88.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63D6D3"
    },
    d: "M196.8,325.6c10.4,14.4,24,21.6,29.6,17.6c6.4-4.8,2.4-19.2-8-33.6s-24-21.6-29.6-17.6 S186.4,311.2,196.8,325.6z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterdrop);
export default __webpack_public_path__ + "static/media/waterdrop.0ccaf9c23fe424c7f4c34d52cb180928.svg";
export { ForwardRef as ReactComponent };